import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { REACT_APP_I18_LANG } from "./config";

void i18n.use(initReactI18next).init({
  debug: false,
  showSupportNotice: false,
  lng: REACT_APP_I18_LANG,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: {
        login_page: {
          login_title_text: "login",
          username_text: "username",
          password_text: "password",
          button_text: "login",
        },
      },
    },
    ru: {
      translation: {
        login_page: {
          login_title_text: "вход",
          username_text: "логин",
          password_text: "пароль",
          button_text: "войти",
        },
      },
    },
  },
});

export default i18n;
